import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import pubgImage from "../../assets/img/pubgmobileffqadiraz1.png";
import tiktokImage from "../../assets/img/ffqadiraztiktok.png";
import mobileLegendsImage from "../../assets/img/mobildio.jpeg";
import freeFireImage from "../../assets/img/freeFiredio.jpeg";
import fanImage from "../../assets/img/ffqadirfanlar.png";
import loungeImage from "../../assets/img/fflng.png";

const games = [
  {
    id: 1,
    title: "PUBG Mobile",
    image: pubgImage,
    path: "/pubg",
    tag: "PUBG UC",
  },
  {
    id: 2,
    title: "TikTok Jeton",
    image: tiktokImage,
    path: "/tiktok",
    tag: "JETON",
  },
  {
    id: 4,
    title: "FreeFire",
    image: mobileLegendsImage,
    path: "/freeFire",
    tag: "DIAMOND",
  },
  {
    id: 3,
    title: "Mobile Legends",
    image: freeFireImage,
    path: "/mobileLegends",
    tag: "DIAMOND",
  },
  {
    id: 5,
    title: "Telefon Fanları",
    image: fanImage,
    path: "/mobileAccessory",
    tag: "AKSESUAR",
  },
  {
    id: 6,
    title: "Lounge",
    image: loungeImage,
    path: "/lounge",
    tag: "LOUNGE",
  },
];

const Games = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false, // Animasiya hər dəfə scroll edəndə təkrar işləyəcək
      mirror: true, // Yuxarı scroll edəndə də animasiyanın təkrar olunmasını təmin edir
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <section
      id="games"
      className="relative overflow-hidden bg-white py-8 sm:py-10 text-slate-900 transition-colors duration-500 dark:bg-[#07070b] dark:text-white"
    >
      {/* BACKGROUND DECORATIONS */}
      <div className="pointer-events-none absolute inset-0">
        <div
          data-aos="fade-right"
          data-aos-delay="100"
          className="absolute left-[-120px] top-20 h-72 w-72 rounded-full bg-fuchsia-500/10 blur-[110px]"
        />
        <div
          data-aos="fade-left"
          data-aos-delay="200"
          className="absolute bottom-20 right-[-100px] h-80 w-80 rounded-full bg-cyan-500/10 blur-[120px]"
        />

        <div
          className="absolute inset-0 opacity-[0.035] dark:opacity-[0.045]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(148,163,184,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,.5) 1px, transparent 1px)",
            backgroundSize: "45px 45px",
          }}
        />
      </div>

      <div className="relative mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
     

        {/* ALL 6 CARDS ARE 2-COLUMNS ON MOBILE */}
        <div className="grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3">
          {games.map((game, index) => (
            <Link
              key={game.id}
              to={game.path}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              data-aos-duration="600"
              className="group relative min-h-[150px] sm:min-h-[220px] overflow-hidden rounded-2xl sm:rounded-[1.6rem] border border-slate-200 bg-slate-50 transition-all duration-500 hover:-translate-y-1 hover:border-fuchsia-400/40 hover:shadow-xl hover:shadow-fuchsia-500/10 dark:border-white/10 dark:bg-[#101016]"
            >
              {/* IMAGE */}
              <div className="absolute inset-0 flex items-center justify-center p-3 sm:p-6">
                <img
                  src={game.image}
                  alt={game.title}
                  className="h-full w-full object-contain drop-shadow-[0_10px_20px_rgba(0,0,0,.25)] transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              {/* OVERLAY */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent opacity-90" />

              {/* NUMBER BADGE */}
              <span className="absolute right-2.5 top-1.5 sm:right-4 sm:top-3 text-2xl sm:text-4xl font-black text-white/10">
                0{index + 1}
              </span>

              {/* CARD INFO */}
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5">
                <span className="block text-[8px] sm:text-[9px] font-bold uppercase tracking-[0.15em] sm:tracking-[0.18em] text-white/50">
                  {game.tag}
                </span>

                <h3 className="mt-0.5 sm:mt-1 text-xs sm:text-lg font-black text-white leading-tight">
                  {game.title}
                </h3>
              </div>

              {/* BOTTOM HIGHLIGHT LINE */}
              <div
                className={`absolute bottom-0 left-0 h-[3px] w-0 transition-all duration-500 group-hover:w-full ${
                  index % 2 === 0 ? "bg-fuchsia-500" : "bg-cyan-500"
                }`}
              />
            </Link>
          ))}
        </div>

        {/* BOTTOM LINE */}
        <div
          data-aos="fade-up"
          data-aos-delay="300"
          className="mt-8 sm:mt-10 flex items-center justify-center gap-2"
        >
          <span className="h-px w-16 bg-gradient-to-r from-transparent to-slate-200 dark:to-white/10" />
          <span className="h-1 w-1 rounded-full bg-fuchsia-500/60" />
          <span className="h-px w-5 bg-fuchsia-500/30" />
          <span className="h-1.5 w-1.5 rounded-full bg-cyan-500/60" />
          <span className="h-px w-16 bg-gradient-to-l from-transparent to-slate-200 dark:to-white/10" />
        </div>
      </div>
    </section>
  );
};

export default Games;